import React, { useState } from "react";
import Home from "./assets/components/Home";
import LogIn from "./assets/components/LogIn";
import ForgotPassword from "./assets/components/ForgotPassword";
import SignIn from "./assets/components/SignIn";
import Mailsent from "./assets/components/Mailsent";
import ListaVideos from "./assets/components/ListaVideos";
import VerVideos from "./assets/components/VerVideo";
import RecoverPassword from "./assets/components/RecoverPassword";
function App() {
  const [estado, setEstado] = useState({ n: 0, data: {} });
  switch (estado.n) {
    case 1: //Ingresar;
      return <LogIn setEstado={setEstado} />;

    case 2: //Registarse;
      return <SignIn setEstado={setEstado} />;

    case 3: //Pagan de videos;
      return (
        <Mailsent texto="Se te envió un correo a tu cuenta de email para verificar el mismo. Por favor seguí los pasos para activar tu cuenta. Gracias" />
      );

    case 4: //Pagan de videos;
      return <ForgotPassword setEstado={setEstado} />;

    case 5: //Pagan de videos;
      return <RecoverPassword setEstado={setEstado} estado={estado} />;

    case 10: //Pagan de videos;
      return <ListaVideos estado={estado} setEstado={setEstado} />;
    case 11: //Pagan de videos;
      return <VerVideos estado={estado} setEstado={setEstado} />;

    default:
      return <Home setEstado={setEstado} />;
  }
}
export default App;
